var _Elearning;
import { clsx } from "clsx";
import { useTranslation } from "@crehana/i18n";
import Elearning from "@crehana/icons/logos/Elearning";
import ArrowIosLeft from "@crehana/icons/outline/ArrowIosLeft";
import { neutralDark, neutralLight } from "@crehana/tailwindcss/colors";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var NewSidebarV2Header = function NewSidebarV2Header(_ref) {
  var sidebarCollapsed = _ref.sidebarCollapsed,
    hasTalentProduct = _ref.hasTalentProduct,
    isDark = _ref.isDark,
    organizationSlug = _ref.organizationSlug;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx("div", {
    className: "wp-head w-full flex flex-col",
    children: hasTalentProduct && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: "wp-come-back tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-01",
        children: /*#__PURE__*/_jsxs("a", {
          className: clsx('flex items-center w-full px-12 py-16', sidebarCollapsed && 'justify-center'),
          href: "/org/".concat(organizationSlug, "/home/"),
          children: [/*#__PURE__*/_jsx(ArrowIosLeft, {
            size: 20,
            color: isDark ? neutralDark['400'] : neutralLight['700'],
            className: "icon-come-back"
          }), !sidebarCollapsed ? /*#__PURE__*/_jsx("p", {
            className: "tw-font-link1 tw-text-neutral-light-700 dark:tw-text-neutral-dark-400 ml-4",
            children: t('LABEL_SIDEBAR_ITEM_COMEBACK')
          }) : /*#__PURE__*/_jsx("p", {
            className: "tw-font-link1 tw-text-neutral-light-700 dark:tw-text-neutral-dark-400 ml-4",
            children: t('LABEL_SIDEBAR_ITEM_COMEBACK_SHORT')
          })]
        })
      }), !sidebarCollapsed && /*#__PURE__*/_jsxs("div", {
        className: "tw-w-full tw-flex tw-items-center tw-px-1.2 tw-pb-1.6 tw-pt-2 tw-border-t tw-border-solid dark:tw-border-neutral-dark-700 tw-border-neutral-light-300",
        children: [/*#__PURE__*/_jsx("div", {
          className: "tw-w-[40px] tw-h-[40px] tw-rounded-[6px] tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-01 tw-flex tw-items-center tw-justify-center ",
          style: {
            border: isDark ? '0.5px solid #292C47' : '0.5px solid #E3E4E5'
          },
          children: _Elearning || (_Elearning = /*#__PURE__*/_jsx(Elearning, {
            size: 24,
            className: "tw-text-primary-light-500 dark:tw-text-secondary-dark-300"
          }))
        }), /*#__PURE__*/_jsx("span", {
          className: "tw-font-subtitle4 tw-text-neutral-light-700 dark:tw-text-neutral-dark-400 ml-12",
          children: t('LABEL_SIDEBAR_ITEM_TITLE')
        })]
      })]
    })
  });
};
export default NewSidebarV2Header;